import React from "react";

const PerformanceMain = () => {
    return(
        <div className="playbox_perf_main">
            Performance main
        </div>
    )
}

export default PerformanceMain